module.exports = __webpack_public_path__ + "static/media/beef-is-the-greatest.2e6de6a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/beef-is-the-greatest.jpg
// module id = 1433
// module chunks = 0